"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var useAccordionContext_1 = require("./useAccordionContext");
var styled_1 = __importDefault(require("./styled"));
var AccordionPanel = function (_a) {
    var index = _a.index, children = _a.children;
    var findExpanded = (0, useAccordionContext_1.useAccordionContext)().findExpanded;
    var isExpanded = findExpanded(index);
    return (react_1.default.createElement(Box_1.default, { column: true, flex: true, role: "region", id: "accordion-item-" + index, "aria-labelledby": "button-id-" + index },
        react_1.default.createElement(styled_1.default.PanelBody, { column: true, flex: true, expanded: isExpanded, "data-testid": "accordion-panel-" + index }, children)));
};
exports.default = AccordionPanel;
